import cx from 'classnames';
import React from 'react';
export const Text = ({ caption, children, className, contrast, is: Tag = 'span', weight, ...rest }) => (React.createElement(Tag, { className: cx({
        [`tds-text--contrast-${contrast}`]: contrast,
        [`tds-text--${weight}`]: weight,
        'tds-text--caption': caption,
    }, className), ...rest }, children));
